import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _typeof from 'babel-runtime/helpers/typeof';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var defaultParseOptions = {
  decodeValues: true
};

function extend(target, source) {
  return _Object$keys(source).reduce(function (target, key) {
    target[key] = source[key];
    return target;
  }, target);
}

function isNonEmptyString(str) {
  return typeof str == 'string' && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(';').filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part
  var cookie = {
    name: name, // grab everything before the first =
    value: options.decodeValues ? decodeURIComponent(value) : value // decode cookie value
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key == "expires") {
      cookie.expires = new Date(value);
    } else if (key == 'max-age') {
      cookie.maxAge = parseInt(value, 10);
    } else if (key == 'secure') {
      cookie.secure = true;
    } else if (key == 'httponly') {
      cookie.httpOnly = true;
    } else if (key == 'samesite') {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  if (!input) {
    return [];
  }
  if (input.headers) {
    input = input.headers['set-cookie'];
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  var defaultOptions = extend({}, defaultParseOptions);
  if (options) {
    options = extend(defaultOptions, options);
  } else {
    options = defaultOptions;
  }

  return input.filter(isNonEmptyString).map(function (str) {
    return parseString(str, options);
  });
}

var setCookie = parse;
var parse_1 = parse;
setCookie.parse = parse_1;

/*!
 * on-headers
 * Copyright(c) 2014 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Execute a listener when a response is about to write headers.
 *
 * @param {Object} res
 * @return {Function} listener
 * @api public
 */

var onHeaders = function onHeaders(res, listener) {
  if (!res) {
    throw new TypeError('argument res is required');
  }

  if (typeof listener !== 'function') {
    throw new TypeError('argument listener must be a function');
  }

  res.writeHead = createWriteHead(res.writeHead, listener);
};

function createWriteHead(prevWriteHead, listener) {
  var fired = false;

  // return function with core name and argument list
  return function writeHead(statusCode) {
    // set headers from arguments
    var args = setWriteHeadHeaders.apply(this, arguments);

    // fire listener
    if (!fired) {
      fired = true;
      listener.call(this);

      // pass-along an updated status code
      if (typeof args[0] === 'number' && this.statusCode !== args[0]) {
        args[0] = this.statusCode;
        args.length = 1;
      }
    }

    prevWriteHead.apply(this, args);
  };
}

function setWriteHeadHeaders(statusCode) {
  var length = arguments.length;
  var headerIndex = length > 1 && typeof arguments[1] === 'string' ? 2 : 1;

  var headers = length >= headerIndex + 1 ? arguments[headerIndex] : undefined;

  this.statusCode = statusCode;

  // the following block is from node.js core
  if (Array.isArray(headers)) {
    // handle array case
    for (var i = 0, len = headers.length; i < len; ++i) {
      this.setHeader(headers[i][0], headers[i][1]);
    }
  } else if (headers) {
    // handle object case
    var keys = _Object$keys(headers);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k) this.setHeader(k, headers[k]);
    }
  }

  // copy leading arguments
  var args = new Array(Math.min(length, headerIndex));
  for (var i = 0; i < args.length; i++) {
    args[i] = arguments[i];
  }

  return args;
}

/**
 * Constructor for HTTP errors which can include a stack trace in addition to
 * the response information.
 */
var HttpError = function (_Error) {
  _inherits(HttpError, _Error);

  function HttpError(resp) {
    var callStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, HttpError);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, (HttpError.__proto__ || _Object$getPrototypeOf(HttpError)).call(this, resp.status + " " + resp.statusText + " " + resp.url));
    // Set message and stack-trace


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, HttpError);
    }

    // Custom debugging information

    _this.errorCode = body && (typeof body === "undefined" ? "undefined" : _typeof(body)) === "object" && body.hasOwnProperty("errorCode") ? Number(body.errorCode) : 0;

    // We skip the headers for now since we cannot serialize them
    //this.httpHeaders  = resp.headers;
    _this.httpUrl = resp.url;
    _this.httpOk = resp.ok;
    _this.httpStatus = resp.status;
    _this.httpStatusText = resp.statusText;
    _this.httpRedirected = resp.redirected;
    _this.httpType = resp.type;
    _this.httpBody = body;
    _this.callStack = callStack;
    return _this;
  }

  return HttpError;
}(Error);

/**
 * Appends a list of header pairs to the given Request|RequestOptions object.
 *
 * NOTE: Modifies arguments in-place.
 */
var appendHeaders = function appendHeaders(init, headers) {
  init.headers = headers.reduce(function (a, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    a[k] = v;

    return a;
  }, init.headers || {});
};

/**
 * Prefixes the URL in the fetch request with the given string.
 */
var prefix = function prefix(fetch, _prefix) {
  return function (input, init) {
    if (typeof input !== "string") {
      input.url = _prefix + input.url;
    } else {
      input = _prefix + input;
    }

    return fetch(input, init);
  };
};

/**
 * Adds the crendentials setting to the requests, defaults to `same-origin`.
 */
var withCookies = function withCookies(fetch) {
  var credentials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "same-origin";
  return function (input, init) {
    if ((typeof input === "undefined" ? "undefined" : _typeof(input)) === "object") {
      input.credentials = credentials;
    } else {
      init = init || {};

      init.credentials = credentials;
    }

    return fetch(input, init);
  };
};

/**
 * Normally any non-network error will still result in a success (eg. 404 still behaves like a success),
 * this wrapper will reject any response which is not 200 <= status < 300.
 *
 * The response data will be merged with the response object itself if it is a JSON-response, the
 * response keys will be prefixed with `http`.
 */
var rejectOnHttpError = function rejectOnHttpError(fetch) {
  return function (input, init) {
    // Store a stack-trace here in case we error
    var stackTrace = null;

    // Skip this for production
    if (process.env.NODE_ENV !== "production") {
      stackTrace = new Error("fetch() called here");
    }

    return fetch(input, init).then(function (resp) {
      if (resp instanceof Response && !resp.ok) {
        return resp.json().then(function (errData) {
          throw new HttpError(resp, stackTrace, errData);
        },
        // We might fail JSON-parse
        function () {
          throw new HttpError(resp, stackTrace);
        });
      }

      return resp;
    });
  };
};

/**
 * Applies configuration for node-fetch.
 */
var nodeFetchConfig = function nodeFetchConfig(fetch, configuration) {
  return function (input, init) {
    if ((typeof input === "undefined" ? "undefined" : _typeof(input)) === "object") {
      if (configuration.keepAlive) {
        input.headers.set("Connection", "Keep-Alive");
      }

      for (var k in configuration) {
        if (configuration.hasOwnProperty(k)) {
          input[k] = configuration[k];
        }
      }
    } else {
      init = init || {};

      if (configuration.keepAlive) {
        appendHeaders(init, [["Connection", "Keep-Alive"]]);
      }

      init = _extends({}, init, configuration);
    }

    return fetch(input, init);
  };
};

/**
 * Registers a callback which will receive all responses from the wrapped fetch.
 */
var observeResponse = function observeResponse(fetch, cb) {
  return function (input, init) {
    return fetch(input, init).then(function (resp) {
      cb(null, resp);

      return resp;
    }, function (resp) {
      cb(resp, null);

      throw resp;
    });
  };
};

/**
 * Sets headers supplied as an object on the fetch request.
 */
var setHeaders = function setHeaders(fetch, headers) {
  return function (input, init) {
    if (typeof input !== "string") {
      // We have a fetch Request as input
      _Object$keys(headers).forEach(function (k) {
        return input.headers.set(k, headers[k]);
      });
    } else {
      init = init || {};

      appendHeaders(init, _Object$keys(headers).map(function (headerName) {
        return [headerName, headers[headerName]];
      }));
    }

    return fetch(input, init);
  };
};

/**
 * Proxies select headers from an Express Request to fetch.
 */
var proxyHeaders = function proxyHeaders(fetch, req, headers) {
  return function (input, init) {
    if (typeof input !== "string") {
      // We have a fetch Request as input
      for (var i = 0; i < headers.length; i++) {
        var name = headers[i];
        var value = req.get(name);

        if (value) {
          input.headers.set(name, value);
        }
      }
    } else {
      init = init || {};

      appendHeaders(init, headers.filter(function (headerName) {
        return req.get(headerName);
      }).map(function (headerName) {
        return [headerName, req.get(headerName)];
      }));
    }

    return fetch(input, init);
  };
};

/**
 * Passes specific response headers to an Express Response.
 */
var addHeaders = function addHeaders(resp, res, headers) {
  return !res.headersSent && headers.filter(function (headerName) {
    return resp.headers.has(headerName);
  }).forEach(function (headerName) {
    return res.set(headerName, resp.headers.get(headerName));
  });
};

/**
 * Pass specific headers from the fetch response to an Express Response.
 */
var passHeaders = function passHeaders(fetch, res, headers) {
  return function (input, init) {
    return fetch(input, init).then(function (resp) {
      addHeaders(resp, res, headers);

      return resp;
    }, function (resp) {
      if ((typeof resp === "undefined" ? "undefined" : _typeof(resp)) === "object" && _typeof(resp.headers) === "object" && resp.headers.has && resp.headers.get) {
        addHeaders(resp, res, headers);
      }

      // Rethrow
      throw resp;
    });
  };
};

var encodeCookies = function encodeCookies(cookies) {
  return _Object$keys(cookies).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(cookies[key]);
  }).join("; ");
};

/**
 * Usage requires cookie-parser middleware installed in Express.
 */
var proxyCookies = function proxyCookies(fetch, req, res) {
  var cookies = req.cookies || {};
  var newCookies = {};
  var eatCookie = function eatCookie(resp) {
    if (resp.headers.has("Set-Cookie")) {
      setCookie.parse(resp.headers.getAll("Set-Cookie")).forEach(function (_ref3) {
        var name = _ref3.name,
            value = _ref3.value,
            options = _objectWithoutProperties(_ref3, ["name", "value"]);

        if (options.maxAge) {
          // For some reason Express likes to have maxAge set in milliseconds
          options.maxAge *= 1000;
        }

        cookies[name] = value;
        newCookies[name] = {
          value: value,
          options: options
        };
      });
    }

    return resp;
  };

  onHeaders(res, function () {
    return _Object$keys(newCookies).forEach(function (k) {
      return res.cookie(k, newCookies[k].value, newCookies[k].options);
    });
  });

  return function (input, init) {
    if (typeof input !== "string") {
      input.headers.set("Cookie", encodeCookies(cookies));
    } else {
      init = init || {};

      appendHeaders(init, [["Cookie", encodeCookies(cookies)]]);
    }

    return fetch(input, init).then(eatCookie);
  };
};
var jsonResponse = function jsonResponse(resp) {
  return resp.json();
};

/**
 * Constructs the options array for a fetch call containing JSON.
 *
 * Stringifies any data present on `data`, adds `Content-Type: application/json`
 * and defaults `method` to `POST`.
 */
var sendJson = function sendJson(init) {
  appendHeaders(init, [["Content-Type", "application/json"]]);

  if (!init.method) {
    init.method = "POST";
  }

  init.body = _JSON$stringify(init.body);

  return init;
};

export { HttpError, appendHeaders, prefix, withCookies, rejectOnHttpError, nodeFetchConfig, observeResponse, setHeaders, proxyHeaders, passHeaders, proxyCookies, jsonResponse, sendJson };
//# sourceMappingURL=index.es2015.js.map
